import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import * as Styled from './styled';
import type { EmptyOverlayProps } from './types';

export * from './types';

export const EmptyOverlay: FC<EmptyOverlayProps> = (props) => {
  const { translate } = useTranslation();

  const {
    wrapperProps,
    icon = <FaExclamationTriangle />,
    title = <>{translate('glossary.empty')}</>,
    text,
    children,
  } = props;

  return (
    <Styled.Wrapper {...wrapperProps}>
      <Styled.IconWrapper>{icon}</Styled.IconWrapper>
      <Styled.Title>{title}</Styled.Title>
      {text && <Styled.Text>{text}</Styled.Text>}
      {children}
    </Styled.Wrapper>
  );
};
